import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { SERVER_TIMEZONE } from '../constants';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * Function that formats date to specified `formatString`
 * and to declared timezone
 *
 * @param {string} dateString
 * @param {string} formatString
 * @returns {string} formatted date
 *
 * @example
 * const eventDateTime = '2020-09-02T10:58:29.486Z'
 * formattedDate(eventDateTime, 'MMM D') => 'Sep 02'
 */
export function formattedDate(dateString, formatString) {
    return dayjs(dateString).tz(SERVER_TIMEZONE).format(formatString);
}
/**
 * Function that checks if ACH transfer is past deliverOnDate
 *
 * @param {string} dateString
 * @returns {boolean}
 *
 * @example
 * const eventDateTime = '2020-09-02T10:58:29.486Z'
 */
export function isAfterDeliverOnDate(deliverOnDateTime) {
    var today = dayjs().tz(SERVER_TIMEZONE);
    var deliverOnDate = dayjs(deliverOnDateTime).tz(SERVER_TIMEZONE);
    return today.isAfter(deliverOnDate, 'day');
}
/**
 *  Function to mask account based on UI standards
 *
 * @param {string} name
 * @param {number} number
 * @returns {string} formatted account info
 *
 * @example
 * const name = 'Savings Account'
 * const number = '123456789'
 * maskAccount(name, number) => 'Savings Account••6789'
 */
export function maskAccount(name, number) {
    return "".concat(name, " \u2022\u2022").concat(number.slice(-4));
}
/**
 * Function to add space between characters
 * Used for a11y so numbers are read correctly
 *
 * @param {string} value
 * @returns {string} formatted value
 *
 */
export function spreadNumberA11y(value) {
    return value.split('').join(' ');
}
//# sourceMappingURL=utils.js.map